// window.CardMap — one coordinate system for every card explorer.
// Truth = card millimetres in the FACE's own frame (mx from that face's left edge, my from its top).
// Photo %, 3D world position and baked block data all derive from mm, so a mark placed in any
// view lands in the same physical spot in the others.
(function () {
  const ap = (m, x, y) => {
    const w = m[2][0] * x + m[2][1] * y + m[2][2];
    return [(m[0][0] * x + m[0][1] * y + m[0][2]) / w, (m[1][0] * x + m[1][1] * y + m[1][2]) / w];
  };
  const mul = (a, b) => a.map(r => b[0].map((_, j) => r[0] * b[0][j] + r[1] * b[1][j] + r[2] * b[2][j]));
  const inv = (m) => {
    const [a, b, c] = m[0], [d, e, f] = m[1], [g, h, i] = m[2];
    const A = e * i - f * h, B = f * g - d * i, C = d * h - e * g;
    const det = a * A + b * B + c * C;
    if (!det) return [[1, 0, 0], [0, 1, 0], [0, 0, 1]];
    return [[A / det, (c * h - b * i) / det, (b * f - c * e) / det],
            [B / det, (a * i - c * g) / det, (c * d - a * f) / det],
            [C / det, (b * g - a * h) / det, (a * e - b * d) / det]];
  };

  // each card supplies a homography per face fitted photo% -> card FRACTION,
  // so mm = diag(W,H) · p2f and photo% = its inverse
  const CARDS = {
    u3: {
      W: 85, H: 55, T: 2,
      p2f: () => ({
        A: [[0.012074, -0.001115, -0.035725], [0.002123, 0.014718, -0.303108], [0, 0, 1]],
        B: [[0.009941, -0.003839, 0.181003], [0.008079, 0.013388, -0.574626], [0, 0, 1]]
      })
    },
    u4: { W: 85, H: 55, T: 2.4, p2f: () => (window.U4 || {}).hom },  // lives in the blocks file
    u5: { W: 85.4, H: 55.4, T: 2.4, p2f: () => (window.U5 || {}).hom },
    ex: { W: 87.39, H: 55.2, T: 3, p2f: () => (window.EX || {}).hom },
    adv: { W: 85, H: 55, T: 3, p2f: () => (window.ADV || {}).hom },
    bush: { W: 85, H: 55, T: 2.4, p2f: () => (window.BUSH || {}).hom },
    dsn: { W: 87, H: 54, T: 1.5, p2f: () => (window.DSN || {}).hom },
    prof: { W: 87.1, H: 54, T: 1.5, p2f: () => (window.PROF || {}).hom },
    ow: { W: 85, H: 55, T: 2, p2f: () => (window.OW || {}).hom }
  };

  const cache = {};
  function p2m(card, side) {
    const C = CARDS[card]; if (!C) return null;
    const k = card + side;
    if (cache[k]) return cache[k];
    const h = C.p2f();
    const m = h && (h[side] || h.A);
    if (!m) return null;                                              // blocks file not in yet
    return (cache[k] = mul([[C.W, 0, 0], [0, C.H, 0], [0, 0, 1]], m));
  }
  const m2p = (card, side) => { const m = p2m(card, side); return m && inv(m); };

  window.CardMap = {
    dims: (card) => CARDS[card],
    ready: (card) => !!p2m(card, 'A'),
    // mm on a face -> % of that face's photo
    toPhoto(card, side, mx, my) {
      const m = m2p(card, side); if (!m) return { x: 50, y: 50 };
      const [x, y] = ap(m, mx, my);
      return { x: x, y: y };
    },
    // % of a photo -> mm on that face
    toMM(card, side, x, y) {
      const m = p2m(card, side); if (!m) return { mx: 0, my: 0 };
      const C = CARDS[card];
      const [mx, my] = ap(m, x, y);
      return { mx: Math.max(0, Math.min(C.W, mx)), my: Math.max(0, Math.min(C.H, my)) };
    },
    // authored position of a tool, whichever way the blocks file spells it
    mmOf(card, t) {
      if (t.mx != null && t.my != null) return { mx: t.mx, my: t.my };
      return this.toMM(card, t.side, t.x || 0, t.y || 0);
    },
    round(v) { return Math.round(v * 10) / 10; }
  };
})();
